import { styled, Box } from "@mui/material";

export const StyledDateOfBirthBox = styled(Box)(() => ({
  maxWidth: "176px",
}));

export const StyledProviderAccountCreationBox = styled(Box)(() => ({
  maxWidth: "504px",
}));
